'use client';
import { css } from 'styled-system/css'

export const bettingModeModalStyle = {
	root: css({
		_mars: {
			backgroundColor: 'white.0',
			rounded: '0px',
			md: {
				rounded: '12px',
				overflow: 'hidden',
				position: 'relative',
			},
			'& .betting-mode-image': {
				'--betslip-image-button': 'colors.bettingModeModal.imageButtonBg',
			},
			'& .betting-mode-image__bottom-label': {
				'--lv2-100': 'colors.whiteOpacity.100',
			},
		},
	}),
	container: css({
		_mars: {
			backgroundColor: 'bettingModeModal.containerBg',
		},
	}),
	header: css({
		_mars: {
			_before: {
				top: 0,
				left: 0,
				w: '120px',
				h: '91px',
				backgroundImage: 'url("/images/betting-mode/left_coin.png")',
				bgRepeat: 'no-repeat',
			},
			_after: {
				top: 0,
				right: 0,
				w: '136px',
				h: '91px',
				backgroundImage: 'url("/images/betting-mode/right_coin.png")',
				bgRepeat: 'no-repeat',
			},
		},
	}),
	img: css({
		_mars: {
			height: '88px',
			backgroundImage: 'url("/images/betting-mode/img_bill.png")',
			bgSize: 'cover',
			bgRepeat: 'no-repeat',
		},
	}),
	title: css({
		_mars: {
			color: 'brand.500_light',
		},
	}),
	tab: css({
		_mars: {
			gap: 0,
			border: '1px solid {colors.black.5}',
			backgroundColor: 'transparent',
			p: 0,
			my: '6px',
			borderRadius: '6px',
		}
	}),
	tabItem: css({
		base: {
			'--s-tab-item-color': { base: 'var(--p500)', _dark: 'white' }
		},
		_mars: {
			border: 'none',
			backgroundColor: 'transparent',
			mr: 0,
			height: '30px',
			'&[data-selected=true]': {
				position: 'relative',
				mt: '-1px',
				mb: '-1px',
				ml: '-1px',
				mr: '-1px',
				color: 'var(--s-tab-item-color)',
				bgColor: 'bettingModeModal.tabItemSelectedBg',
			}
		}
	}),
	tabCheckIcon: css({
		_mars: {
			bgColor: 'secondary.500',
		}
	}),
	image: css({
		base: {
			flex: '1 1 0',
			bgColor: 'white.3',
		},
		_mars: {
			backgroundColor: 'bettingModeModal.imageBg',
		}
	}),
	btn: css({
		_mars: {
			backgroundColor: 'secondary.600',
		}
	}),
	panel: css({
		base: {
			left: 0,
			top: 0,
			right: 0,
			bottom: 0,
			w: '100%',
			h: '100%',
			flex: '0 0 100%',
			display: 'flex',
			flexDirection: 'column',
			rounded: '6px',
		},
	}),
	backButton: css({
		base: {
			display: 'none',
			position: 'absolute',
			color: 'rgba(255, 255, 255, 0.50)',
			alignItems: 'center',
			w: 'auto',
			top: '15px',
			left: '15px',
			zIndex: 1,
			fontSize: '14px',
			fontWeight: '700',
			'& .icon--dropdown': {
				transform: 'rotateZ(90deg)',
				mr: '10px'
			},

			_active: {
				display: 'flex'
			}
		},
		_mars: {
			color: '{colors.black.3}',
		}
	}),
	panelHeader: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			p: '6px 12px',
			height: '36px',
			bgColor: 'brand.500_12',
			fontWeight: '500',
			color: { base: 'primary.600', _dark: 'whiteOpacity.100' },
			rounded: '6px 6px 0 0',
			'& .icon': {
				width: '20px',
				height: '20px',
			}
		},
	}),
	subPanelHeader: css({
		base: {
			justifyContent: 'flex-start',
			cursor: 'pointer',
		},
	}), 
	panelBody: css({
		base: {
			flex: '1',
			rounded: '0 0 6px 6px',
			overflowY: 'auto',
		},
	}),
	panelWrapper: css({
		display: 'flex',
		transition: 'transform 200ms ease-in',
		gap: '12px',
		flex: '1',
		_active: {
			transform: 'translateX(calc(-100% - 12px))',
		},
	})
}